import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { first, flatMap, tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { selectToken } from '@fund-base/store/selectors/auth.selectors';
import { StorageService } from '@fund-base/services/storage/storage.service';
import { authTokenLocalStorageKey } from '@fund-base/constants/auth/auth.constants';
import { setToken, signOut } from '@fund-base/store/actions/auth.actions';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private store: Store,
    private storageService: StorageService,
    private router: Router,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): any {
    return this.store.select(selectToken).pipe(
      first(),
      flatMap(token => {
        if (!token) {
          token = this.storageService.getItem(authTokenLocalStorageKey);
        }
        if (!!token) {
          req = req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) });
        }
        return next.handle(req).pipe(
          tap((event) => {
            // Check for new token in response headers
            if (event instanceof HttpResponse) {
              const newToken = event.headers.get('x-access-token');
              if (newToken && newToken !== token) {
                this.store.dispatch(setToken({ token: newToken }));
                this.storageService.setItem(authTokenLocalStorageKey, newToken);
              }
            }
          }),
          catchError((error: HttpErrorResponse) => {
            // Check for 401 Unauthorized with specific error message
            if (error.status === 401) {
              const errorMessage = error?.error?.message || error?.message || '';
              
              // If token expired and membership is not active, logout user
              if (errorMessage.includes('Token expired and membership is not active') ||
                  errorMessage.includes('Token expired and user/organization not found') ||
                  errorMessage.includes('Token expired and membership validation failed')) {
                // Logout user
                this.store.dispatch(signOut({}));
                this.router.navigate(['/auth']);
              }
            }
            return throwError(() => error);
          }),
        );
      }),
    );
  }
}
